import { render, staticRenderFns } from "./bookingStatus.vue?vue&type=template&id=f353731a&scoped=true"
import script from "./bookingStatus.vue?vue&type=script&lang=js"
export * from "./bookingStatus.vue?vue&type=script&lang=js"
import style0 from "./bookingStatus.vue?vue&type=style&index=0&id=f353731a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f353731a",
  null
  
)

export default component.exports